module.exports = require('./dist/react-data-grid');


//////////////////
// WEBPACK FOOTER
// ./~/react-data-grid/index.js
// module id = 180
// module chunks = 4